import React, { ReactNode, useState } from "react";
import { useTranslations } from "next-intl";

import MultiPurposeInput from "@components/MultiPurposeInput";

import { Button } from "@components/Helpers/UIComponents";
import { InfoCardList } from "../Cards";
import Modal from "../Modal/Modal";

import { spaceTypes } from "@utils/sync/GeneralUtilsClient";

interface SelectableCardsInputProps {
  options: { label: string; value: string }[];
  selectedValues?: string[]; // Optional for multiple selection
  setSelectedValues?: (values: string[]) => void; // Optional setter for multiple selection
  selectedValue?: string; // Optional for single selection
  setSelectedValue?: (value: string) => void; // Optional setter for single selection
  inputLabel: string;
  cardListClassName?: string;
  classNameInput?: string;
  classNameContainer?: string;
  cardClassName?: string;
  classNameIcon?: string;
  popupTitle: string;
  inputIcon: ReactNode;
  listIcons?: any;
  lookType?: "restaurant" | "reservation"; // Optional, default to 'restaurant'
  functionType?: "multiple" | "single"; // Optional, default to 'multiple'
  isFilter?: boolean;
  resetValue?: () => void;
  disabled?: boolean;
}

const SelectableCardsInput: React.FC<SelectableCardsInputProps> = ({
  options,
  selectedValues,
  setSelectedValues,
  selectedValue,
  setSelectedValue,
  inputLabel,
  popupTitle,
  cardListClassName,
  cardClassName,
  classNameInput,
  classNameContainer,
  classNameIcon,
  inputIcon,
  listIcons,
  lookType = "restaurant", // Default to 'restaurant'
  functionType = "multiple", // Default to 'multiple'
  isFilter,
  resetValue,
  disabled,
}) => {
  const g = useTranslations("General");

  const [isOpen, setIsOpen] = useState(false);

  const displayText =
    functionType === "multiple"
      ? selectedValues
          ?.map((value) => (!spaceTypes?.includes(value) ? value : g(value)))
          .join(", ")
      : !spaceTypes?.includes(selectedValue || "")
        ? selectedValue
        : g(selectedValue);

  const handleToggleModal = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
      <MultiPurposeInput
        label={inputLabel}
        text={displayText}
        icon={inputIcon}
        disabled={disabled}
        isDropdown={true}
        isFilter={isFilter}
        isOpen={isOpen}
        onToggle={handleToggleModal}
        classNameInput={classNameInput}
        classNameContainer={classNameContainer}
        classNameIcon={classNameIcon}
        classNamePopup="overflow-y-auto"
        resetValue={resetValue}
      />
      <Modal
        title={popupTitle}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <div className="picker-body">
          <InfoCardList
            options={options}
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            className={cardListClassName}
            classNameCard={cardClassName}
            lookType={lookType}
            icons={listIcons}
            functionType={functionType}
          />
          <Button
            type="button"
            onClick={handleToggleModal}
            className="primary_button flex"
          >
            {g("popupButtonChoose")}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default SelectableCardsInput;
